import React, { Fragment, useState } from 'react';
import cn from 'classnames';

import Header from 'components/Header';
import Footer from 'components/Footer';
import { Button } from 'components/Button';

import style from './style.scss';

const WebBanners = () => {
  const [isModalShowing, setIsModalShowing] = useState(false);

  const handleButtonClick = (e) => {
    e.preventDefault();
    setIsModalShowing(true);
  };

  const handleCloseClick = (e) => {
    e.preventDefault();
    setIsModalShowing(false);
  };

  return (
    <Fragment>
      <Header />
      <section className="container section">
        <div className="grid-container fluid portal page-web-banners">

          <div className="grid-x">
            <div className="cell small-12 card-grid-container">

              <div className={cn('grid-x grid-margin-x page-header', style.pageHeader)}>
                <div className="cell small-12 large-6">
                  <h3>Application Review</h3>
                </div>
                <div className="cell small-12 large-3">
                  <select required="">
                    <option value="">Select a Specialty...</option>
                    <option value="audiology">Audiology</option>
                    <option value="bariatics">Bariatics</option>
                    <option value="chiropractic">Chiropractic</option>
                    <option value="cosmetic">Cosmetic Surgery</option>
                    <option value="dental">Dental</option>
                    <option value="dermatology">Dermatology</option>
                    <option value="fertility">Fertility</option>
                    <option value="general-healthcare">General Healthcare</option>
                    <option value="hair-restoration">Hair Restoration</option>
                    <option value="lasik-vision">Lasik & Vision</option>
                    <option value="medical-devices">Medical Devices</option>
                    <option value="medspa">Medspa</option>
                    <option value="weight-loss">Weight Loss</option>
                  </select>
                </div>
                <div className="cell small-12 large-3">
                  <select required="">
                    <option value="">Filter by Size...</option>
                    <option value="300x250">300x250</option>
                    <option value="160x600">160x600</option>
                    <option value="728x90">728x90</option>
                  </select>
                </div>
              </div>

              <div className="card">
                <div className="card-header">
                  <h5>Medspa &nbsp;–&nbsp; “Apply For A Medspa Loan”</h5>
                </div>
                <div className="grid-x card-grid">
                  <div className="cell small-12 large-4">
                    <div className="grid-x grid-margin-x">
                      <div className="cell small-6">
                        <a href="#banners" className="banner-img size-1" data-toggle="EmbedCodeModal">&nbsp;</a>
                      </div>
                      <div className="cell small-6 action">
                        <h6>300x250</h6>
                        <Button
                          className={cn('button small green', style.button)}
                          onClick={handleButtonClick}
                        >
                          Embed Code
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="cell small-12 large-4">
                    <div className="grid-x grid-margin-x">
                      <div className="cell small-6">
                        <a href="#banners" className="banner-img size-2" data-toggle="EmbedCodeModal">&nbsp;</a>
                      </div>
                      <div className="cell small-6 action">
                        <h6>160x600</h6>
                        <Button
                          className={cn('button small green', style.button)}
                          onClick={handleButtonClick}
                        >
                          Embed Code
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="cell small-12 large-4">
                    <div className="grid-x grid-margin-x">
                      <div className="cell small-6">
                        <a href="#banners" className="banner-img size-3" data-toggle="EmbedCodeModal">&nbsp;</a>
                      </div>
                      <div className="cell small-6 action">
                        <h6>728x90</h6>
                        <Button
                          className={cn('button small green', style.button)}
                          onClick={handleButtonClick}
                        >
                          Embed Code
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-header">
                  <h5>Chiropractic &nbsp;–&nbsp; “Apply For A Chiropractic Loan”</h5>
                </div>
                <div className="grid-x card-grid">
                  <div className="cell small-12 large-4">
                    <div className="grid-x grid-margin-x">
                      <div className="cell small-6">
                        <a href="#banners" className="banner-img size-1" data-toggle="EmbedCodeModal">&nbsp;</a>
                      </div>
                      <div className="cell small-6 action">
                        <h6>300x250</h6>
                        <Button
                          className={cn('button small green', style.button)}
                          onClick={handleButtonClick}
                        >
                          Embed Code
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="cell small-12 large-4">
                    <div className="grid-x grid-margin-x">
                      <div className="cell small-6">
                        <a href="#banners" className="banner-img size-2" data-toggle="EmbedCodeModal">&nbsp;</a>
                      </div>
                      <div className="cell small-6 action">
                        <h6>160x600</h6>
                        <Button
                          className={cn('button small green', style.button)}
                          onClick={handleButtonClick}
                        >
                          Embed Code
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="cell small-12 large-4">
                    <div className="grid-x grid-margin-x">
                      <div className="cell small-6">
                        <a href="#banners" className="banner-img size-3" data-toggle="EmbedCodeModal">&nbsp;</a>
                      </div>
                      <div className="cell small-6 action">
                        <h6>728x90</h6>
                        <Button
                          className={cn('button small green', style.button)}
                          onClick={handleButtonClick}
                        >
                          Embed Code
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-header">
                  <h5>Funeral &nbsp;–&nbsp; “Apply For A Funeral Loan”</h5>
                </div>
                <div className="grid-x card-grid">
                  <div className="cell small-12 large-4">
                    <div className="grid-x grid-margin-x">
                      <div className="cell small-6">
                        <a href="#banners" className="banner-img size-1" data-toggle="EmbedCodeModal">&nbsp;</a>
                      </div>
                      <div className="cell small-6 action">
                        <h6>300x250</h6>
                        <Button
                          className={cn('button small green', style.button)}
                          onClick={handleButtonClick}
                        >
                          Embed Code
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="cell small-12 large-4">
                    <div className="grid-x grid-margin-x">
                      <div className="cell small-6">
                        <a href="#banners" className="banner-img size-2" data-toggle="EmbedCodeModal">&nbsp;</a>
                      </div>
                      <div className="cell small-6 action">
                        <h6>160x600</h6>
                        <Button
                          className={cn('button small green', style.button)}
                          onClick={handleButtonClick}
                        >
                          Embed Code
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="cell small-12 large-4">
                    <div className="grid-x grid-margin-x">
                      <div className="cell small-6">
                        <a href="#banner" className="banner-img size-3" data-toggle="EmbedCodeModal">&nbsp;</a>
                      </div>
                      <div className="cell small-6 action">
                        <h6>728x90</h6>
                        <a href="#banner" className="button small green" data-toggle="EmbedCodeModal">Embed Code</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </section>
      <Footer />
      <div className={cn('reveal-overlay', style.reveal)} style={{ display: isModalShowing ? 'flex' : 'none' }}>
        <div className={cn('reveal', style.insideReveal)} id="EmbedCodeModal" data-reveal="" data-close-on-click="true" data-animation-in="slide-in-up" data-animation-out="slide-out-down" role="dialog" aria-hidden="true" data-yeti-box="EmbedCodeModal" data-resize="EmbedCodeModal" data-e="stwa5w-e" tabIndex="-1" style={{ display: 'block', top: '136px' }} data-events="resize">
          <div className={cn('card-header', style.cardHeader)}>
            <h5>Embed Code</h5>
          </div>

          <div className="grid-x">
            <div className="cell small-12">
              <div className={cn('form-group', style.noBottom)}>
                <div className="grid-x grid-margin-x">
                  <div className="cell shrink">
                    <img src="https://secure.lendingusa.com//web_ads/FuneralBanner3_300x250.gif" alt="Banner" />
                  </div>
                  <div className="cell auto">
                    <label className="has-value"><span>HTML Embed Code</span>
                      <textarea><a href="https://secure.lendingusa.com/secure/credit_app.aspx?lm=1&amp;indie=tRV3&amp;iframe=2&amp;aid=uRX4eUBxBy%2FbQH0110gdYQ%3D%3D&amp;pid=2652" border="0" rel="noopener noreferrer" target="_blank"> <img src="https://secure.lendingusa.com//web_ads/FuneralBanner3_300x250.gif" alt="Banner" border="0" /></a></textarea>
                    </label>
                    <button className={cn('button green w-100', style.noMarginBottom)}>Copy Code to Clipboard</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button className="close-button" data-close="" aria-label="Close reveal" type="button" onClick={handleCloseClick}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default WebBanners;



// WEBPACK FOOTER //
// ./src/containers/pages/WebBanners/index.js